import { render, staticRenderFns } from "./selctHeader.vue?vue&type=template&id=267bb3b2&scoped=true&"
import script from "./selctHeader.vue?vue&type=script&lang=js&"
export * from "./selctHeader.vue?vue&type=script&lang=js&"
import style0 from "./selctHeader.vue?vue&type=style&index=0&id=267bb3b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267bb3b2",
  null
  
)

export default component.exports